import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Grid,
    Modal,
    Paper,
    TextareaAutosize,
    TextField,
    Typography
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import theme from "../../styles/theme";
import _ from "lodash";
import useStyles from "../../styles/styles";
import useFormInputs from "../../hooks/useFormInputs";
import ConfigFields from "./ConfigFields";
import ConfigImportTable from "./ConfigImportTable";
import {isPairCategory} from "../../utils/configUtils";
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';

const ConfigListModal = ({ data, modalData, closeModal, setFinalValue}) => {
    const classes = useStyles();
    const [view, setView] = useState('listView');
    const [matches, setMatches] = useState([]);
    const [promoIds, setPromoIds] = useState({
        arr: [],
        err: false
    });
    const [duplicates, setDuplicates] = useState([]);
    const [errors, setErrors] = useState([]);
    const [list, setList] = useState([]);
    const textAreaRef = useRef(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const onSubmit = () => {
        setSubmitLoading(true);
        setErrors([]);
        let newValue = list.split('\n');
        let inputError = false;
        if (modalData.isPair) {
            newValue = newValue.map(item => {
                const split = item.replace(/\,/,'&').split('&');
                return ({
                    key: split[0].toLowerCase(),
                    value: split[1]
                });
            });
        } else {
            newValue = newValue.map(item => item.toLowerCase());
        }
        const { key, category } = inputs;
        const newData = {
            key,
            category,
        };
        if (duplicates.length) {
            newValue = _.uniqWith(newValue, _.isEqual);
        }

        Object.keys(newData).forEach(key => {
            const value = newData[key]
            if (value === '') {
                inputError = true;
            }
        });

        if (modalData.data.id) {
            newData.id = modalData.data.id;
        }
        if (!inputError) {
            if (modalData.showAddRow) {
                modalData.triggerCreate(newValue, newData);
            } else {
                modalData.triggerUpdate(newValue, newData);
            }
        } else {
            setSubmitLoading(false);
            setErrors(['error']);
        }
    };
    const {inputs, handleSubmit, setInputs} = useFormInputs(onSubmit);

    useEffect(() => {
        if (modalData) {
            if (modalData.value) {
                setList(modalData.value);
            }
            setInputs(inputs => ({
                ...inputs,
                key: modalData.data.key || '',
                category: modalData.data.category || '',
                type: modalData.data.type || ''
            }));
            data.categories = {
                enumValues: [
                    {
                        name: 'AFFILIATE_KEY_LIST',
                    }, {
                        name: 'TRAFFIC_SOURCE_ID_LIST'
                    }, {
                        name: 'TRAFFIC_SOURCE_ID_SUBCODE'
                    }, {
                        name: 'TRAFFIC_SOURCE_ID_SUBCODE_HASH_LIST'
                    }, {
                        name: 'TRAFFIC_SOURCE_ID_REFERRING_SITE_URL'
                    }, {
                        name: 'AFFILIATE_KEY_SUBCODE_LIST'
                    }, {
                        name: 'AFFILIATE_KEY_SUBCODE_HASH_LIST'
                    }, {
                        name: 'AFFILIATE_KEY_REFERRING_SITE_URL'
                    }, {
                        name: 'REFERRING_SITE_URL_LIST'
                    }, {
                        name: 'TRAFFIC_SOURCE_ID_FIELD_VALUE_LIST'
                    }, {
                        name: 'AFFILIATE_KEY_FIELD_VALUE_LIST'
                    }, {
                        name: 'VEHICLE_MAKE_LIST'
                    }, {
                        name: 'VEHICLE_MODEL_LIST'
                    }
                ],
            };

            resetTypes();
            getModalTitle(modalData.category);
        }
    }, []);

    useEffect(() => {
        if (inputs) {
            if (inputs.category) {
                modalData.category = inputs.category;
            }

            if (inputs.type) {
                modalData.isPair = isPairCategory(inputs.category);
            }
            getModalTitle(inputs.category);
            resetTypes();
        }
    }, [inputs]);

    useEffect(() => {
        if (list.length) {
            triggerList();
            //Set Height Match Height
            // setHeight(textAreaRef.current.clientHeight);
        } else {
            setMatches([]);
        }
    }, [list]);

    const resetTypes = () => {
        if (isPairCategory(modalData.category)) {
            data.types = {
                enumValues: [
                    {
                        name: 'LIST_PAIR_STRING'
                    }
                ],
            };
        } else {
            data.types = {
                enumValues: [
                    {
                        name: 'LIST_STRING'
                    }
                ],
            };
        }
    };

    const triggerList = () => {
        const arr = list.includes('\n') ? list.split('\n') : [list];
        const categoryName = modalData.category;
        let matchArr = [];
        let hasDuplicates = [];
        if (categoryName.includes('TRAFFIC_SOURCE_ID')) {
            matchArr = checkMatches('Traffic Source', data.allTrafficSource.nodes, arr);
        } else {
            matchArr = checkMatches('Affiliate', data.allAffiliate.nodes, arr);
        }

        getModalTitle(categoryName);
        setMatches(matchArr);
    };

    const getModalTitle = (name) => {
        let title;
        switch (name) {
            case 'TRAFFIC_SOURCE_ID_LIST':
                title = 'Traffic Sources';
                break;
            case 'TRAFFIC_SOURCE_ID_SUBCODE_LIST':
                title = 'Traffic Sources - Subcode List';
                break;
            case 'TRAFFIC_SOURCE_ID_SUBCODE_HASH_LIST':
                title = 'Traffic Source - Subcode Hash List';
                break;
            case 'TRAFFIC_SOURCE_ID_REFERRING_SITE_URL_LISY':
                title = 'Traffic Source - Referring Site Url List';
                break;
            case 'AFFILIATE_KEY_SUBCODE_LIST':
                title = 'Affilaite Key - Subcode List';
                break;
            case 'AFFILIATE_KEY_SUBCODE_HASH_LIST':
                title = 'Affilaite Key - Subcode Hash List';
                break;
            case 'AFFILIATE_KEY_REFERRING_SITE_URL_LIST':
                title = 'Affilaite Key - Referring Site Url List';
                break;
            case 'REFERRING_SITE_URL_LIST':
                title = 'Referring Site URL List';
                break;
            case 'AFFILIATE_KEY_FIELD_VALUE_LIST':
                title = 'Affiliate Key - Field Value List';
                break;
            case 'TRAFFIC_SOURCE_ID_FIELD_VALUE_LIST':
                title = 'Traffic Source Id - Field Value List';
                break;
            case 'FIELD_VALUE_LIST':
                title = 'Field Value List';
                break;
            case 'VEHICLE_MAKE_LIST':
                title = 'Vehicle Make List';
                break;
            case 'VEHICLE_MODEL_LIST':
                title = 'Vehicle Model List';
                break;
            default:
                title = 'Affiliates';
                break;
        }
        if (title) {
            setModalTitle(title);
        }
    };

    /**
     * Checks for matches from what is entered in the list
     * @param type
     * @param nodes
     * @param arr
     * @returns {[]}
     */
    const checkMatches = (type, nodes, arr) => {
        let isMatch = [];
        let matchArr = [];
        arr.forEach((x) => {
            const isPair = modalData.isPair;
            const pair = isPair && x.indexOf(',') ? x.replace(/\,/,'&').split('&') : '';
            isMatch = nodes.filter(node => {
                const id = node.id.toLowerCase();
                if (isPair) {
                    if (pair[0].length) {
                        return id === pair[0].toLowerCase() || node.key === pair[0];
                    }
                    return null;
                } else if (type === 'Traffic Source') {
                    return id === x.toLowerCase();
                }
                return id === x.toLowerCase() || node.key.toLowerCase() === x.toLowerCase();
            });
            if (isMatch.length) {
                const match = isMatch[0];
                let isDuplicate = [];
                if (isPair) {
                    isDuplicate = matchArr.filter(item => item.id === match.id && item.subCode === pair[1]);
                } else {
                    isDuplicate = matchArr.filter(item => item.id === match.id);
                }
                matchArr.push({
                    type,
                    id: match.id,
                    error: false,
                    source: match,
                    subCode: isPair && pair[1] ? pair[1] : '',
                    isPair,
                    isDuplicate: !!isDuplicate.length,
                    isDeleted: match.isDeleted || false
                });
            } else {
                if(modalData.category === "REFERRING_SITE_URL_LIST" || modalData.category === "FIELD_VALUE_LIST" || modalData.category.includes("VEHICLE")) {
                    matchArr.push({
                        type: `No matches will appear for ${modalData.category}`,
                        error: false,
                        source: x,
                        isPair,
                        subCode: '',
                        isDuplicate: false,
                        isDeleted: false
                    });
                } else {
                    matchArr.push({
                        type,
                        error: true,
                        source: x,
                        isPair,
                        subCode: '',
                        isDuplicate: false,
                        isDeleted: false
                    });
                }
            }
        });

        return matchArr;
    };

    const searchByPromoCode = () => {
        let arr = data.allTrafficSource.nodes.filter(item => item.legacyPromoId === parseInt(inputs.promoId));
        setPromoIds({
            arr,
            err: !arr.length
        });
    };

    const setImports = (arr) => {
        let newList = list.length ? list : '';
        arr.forEach((item, idx) => {
            const { id } = item;
            if (idx === 0 && !list.length) {
                newList = id;
            } else {
                newList = newList + '\n' + id;
            }
        });
        setList(newList);
        setView('listView');
        setPromoIds({
            arr: [],
            err: false
        });
        setInputs({
            ...inputs,
            promoId: ''
        });
    };
    
    const isModalError = matches.length ? matches.some(match => match.error) : false;
    const isPairError = matches.length ? matches.some(match => match.isPair && (!match.subCode.length || match.subCode === '')) : false;

    return (
        <Modal
            open={true}
            onClose={closeModal}
        >
            <Container className={classes.modal} maxWidth={false}>
                <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Please add your list
                        of {modalTitle} below.
                    </Typography>
                    {errors.includes('error') ? (
                        <Alert severity="error" style={{ marginBottom: '10px'}}>Please add values to the highlighted fields!</Alert>
                    ) : false}
                    {modalData && modalData.isPair ? (
                        <Alert severity="warning" style={{margin: '5px 0 10px'}}>
                            <strong>Each pair is a line and each pair is separated by a comma.</strong>
                        </Alert>
                    ) : null}
                    <ConfigFields
                        inputs={inputs}
                        setInputs={setInputs}
                        data={data}
                        modalData={modalData}
                        defaultCategory={'categories'}
                    />
                    {modalData && modalData.category.includes('TRAFFIC_SOURCE_ID') && view === 'listView' ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setView('import');
                            }}
                            style={{ marginBottom: '15px' }}
                        >
                           Import Traffic Source by Promo Id
                        </Button>
                    ) : null}
                    {view === 'import' ? (
                        <>
                            <Grid container>
                                <Grid item xs={9}>
                                    <TextField
                                        id="search"
                                        name="promoId"
                                        label="Search by Promo Id"
                                        value={inputs.promoId || ''}
                                        onChange={(e) => {
                                            setInputs(inputs => ({
                                                ...inputs,
                                                promoId: e.target.value,
                                            }));
                                            setPromoIds({
                                                arr: [],
                                                err: false
                                            });
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            if (inputs.promoId) {
                                                searchByPromoCode();
                                            } else {
                                                setPromoIds({
                                                    arr: [],
                                                    err: true
                                                });
                                            }
                                        }}
                                    >
                                        Find Traffic Sources
                                    </Button>
                                </Grid>
                                <Grid item xs={12} style={{ marginTop: '10px'}}>
                                    {promoIds.arr.length ? (
                                        <>
                                            <Alert severity="warning" style={{ marginBottom: '10px'}}>
                                                {promoIds.arr.length} Traffic Sources linked to this promo code - {inputs.promoId}
                                            </Alert>
                                            <ConfigImportTable
                                                arr={promoIds.arr}
                                                setImports={setImports}
                                            />
                                        </>
                                    ) : null}
                                    {promoIds.err ? (
                                        <Alert severity="error">
                                            There are no traffic sources with this promo code - {inputs.promoId}
                                        </Alert>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {promoIds.arr.length ? (
                                <Box
                                    display={"flex"}
                                    alignItems={"center"}
                                    style={{margin: '10px 0'}}
                                    justifyContent={"center"}>
                                    <Box style={{marginRight: '10px'}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setImports(promoIds.arr)}
                                        >
                                            Import All Traffic Sources
                                        </Button>
                                    </Box>
                                    <Box>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setView('listView');
                                                setPromoIds({
                                                    arr: [],
                                                    err: false
                                                });
                                                setInputs({
                                                    ...inputs,
                                                    promoId: ''
                                                });
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            ) : null}
                        </>
                    ) : null}
                    {view === 'listView' ? (
                        <>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        <Box display="flex" flexDirection="row" alignItems="center">
                                            <strong>List Fields</strong>
                                        </Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextareaAutosize
                                        ref={textAreaRef}
                                        style={{width: '100%', height: '320px', overflow: 'scroll'}}
                                        value={list}
                                        onChange={(e) => {
                                            setList(e.target.value);
                                        }}
                                        defaultValue={modalData.value || ''}
                                    />`
                                </Grid>
                                <Grid item xs={6}>
                                    <Box style={{padding: '1px 8px 0', height: '300px', overflowY: 'scroll', overflowX: 'hidden'}}>
                                        {matches.length ? (
                                            <Grid container spacing={2}>
                                                <>
                                                    {matches.map((matchItem, idx) => {
                                                        const { error, type, isPair, source, isDeleted, subCode } = matchItem;
                                                        return (
                                                            <Fragment key={idx.toString()}>
                                                                <Grid
                                                                    item
                                                                    xs={5}
                                                                    style={{
                                                                        marginBottom: '10px',
                                                                        borderBottom: '1px solid #dbdbdb',
                                                                        marginLeft: theme.spacing(1),
                                                                        marginRight: theme.spacing(1),
                                                                        padding: theme.spacing(1),
                                                                    }}
                                                                >
                                                                    {error || isDeleted ? (
                                                                        <>
                                                                            {isDeleted ? (
                                                                                <Alert severity="error">
                                                                                    This {type} -  <em>{list.id}</em> has been deleted!
                                                                                </Alert>
                                                                            ) : null}
                                                                            {error ? (
                                                                                <Typography color="error" variant="body2">
                                                                                    <strong>
                                                                                        Not a valid {type} - <em>{source}</em>.
                                                                                        please double check source {isPair ? 'and make sure each line has a pair' : ''}!
                                                                                    </strong>
                                                                                </Typography>
                                                                            ) : null}
                                                                        </>
                                                                    ) : (
                                                                        <Typography variant="body2">
                                                                            {type === 'Traffic Source' && source.affiliate ? (
                                                                                <>
                                                                                    <strong>Affiliate -</strong>
                                                                                    <em>{source.affiliate.name}</em>
                                                                                    <br/>
                                                                                </>
                                                                            ) : null}
                                                                            <strong>{type} - </strong> {source.name}
                                                                                <>
                                                                                    <br/>
                                                                                    {isPair ? (
                                                                                        <>
                                                                                            <>
                                                                                                <strong>{modalData.category.includes("SUBCODE") ? "Subcode" : "Value" } - </strong>
                                                                                                {subCode.length ? (
                                                                                                    <em>{subCode}</em>
                                                                                                ) : (
                                                                                                    <Alert severity="error">
                                                                                                        {`Missing ${modalData.category.includes("SUBCODE") ? "Subcode" : "Value" }!`}
                                                                                                    </Alert>
                                                                                                )}
                                                                                            </>
                                                                                        </>
                                                                                    ) : null}
                                                                                </>
                                                                        </Typography>
                                                                    )}
                                                                </Grid>
                                                            </Fragment>
                                                        );
                                                    })}
                                                </>
                                            </Grid>
                                        ) : (
                                            <Alert severity="warning">Matches will appear!</Alert>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                            {isModalError ? (
                                <Alert severity='error'>Please remove any items that are not valid in order to save your changes.</Alert>
                            ) : null}
                            <Box
                                display={"flex"}
                                alignItems={"center"}
                                style={{margin: '10px 0'}}
                                justifyContent={"center"}>
                                <Box style={{marginRight: '10px'}}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={submitLoading || !matches.length || isModalError || isPairError}
                                        onClick={() => {
                                            handleSubmit();
                                        }}
                                    >
                                        {submitLoading ? (
                                            <CircularProgress color="inherit"/>
                                        ) : (
                                            <>
                                                Save Values
                                            </>
                                        )}
                                    </Button>
                                </Box>
                                <Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            closeModal();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        </>
                    ) : null}
                </Paper>
            </Container>
        </Modal>
    );
};

export default ConfigListModal;
